import styled from '@emotion/styled';
import { StyledRow, Cell } from './FlightSearchRow';
import { Css, Shimmer } from '../../../../ui';
import { Color } from '../../../../styles/Color';
import { StyledTable } from './FlightSearchDayGroups';

export default function FlightSearchShimmer() {
	return (
		<StyledTable>
			<FlightSearchRowShimmer />
			<FlightSearchRowShimmer />
			<FlightSearchRowShimmer />
		</StyledTable>
	);
}

function FlightSearchRowShimmer() {
	return (
		<StyledRow>
			<Cell width={80}>
				<StyledShimmer />
			</Cell>

			<Cell width={110} hideOnMobile>
				<StyledShimmer />
			</Cell>

			<Cell width={270}>
				<StyledShimmer />
			</Cell>

			<Cell width={140} hideOnTablet>
				<StyledShimmer />
			</Cell>

			<Cell width={70}>
				<StyledShimmer />
			</Cell>
		</StyledRow>
	);
}

const StyledShimmer = styled(Shimmer)`
	width: 100%;
	height: ${Css.pxToRem(16)};

	background-color: ${Color.BodyBackground};
	border-radius: ${Css.pxToRem(4)};
`;
